import uploaderHtml from './uploader.html';
import Resumable from 'resumablejs';

class uploaderController {
    constructor($scope, $http, $timeout) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.$timeout = $timeout

        this.file = null;
        this.uploading = false;
        this.progress = 0;
        this.resumable = null;

        this.allowedExtensions = [];
        this.completeCallback = function(result) {};
        this.errorCallback = function(result) {};
        this.progressCallback = function(result) {};
    }

    $onInit() {
        this.$timeout(() => {
            this.resumable = new Resumable({
                target: this.path,
                testChunks: true,
                fileType: this.allowedExtensions,
                maxFiles: 1,
                permanentErrors:[400, 401, 404, 409, 415, 500, 501]
            });

            const element = document.getElementById('uploader_' + this.name);
            this.resumable.assignBrowse(element);

            this.initEvents();
        }, 500);
    }

    startUpload() {
        this.uploading = true;

        this.resumable.upload();
    }

    pauseUpload() {
        if (this.resumable.files.length > 0 && this.resumable.isUploading()) {
            this.uploading = false;

            this.resumable.pause();
        }
    }

    initEvents() {
        this.resumable.on('fileAdded', (file, event) => {
            this.onFileAdded(file, event);
        });

        this.resumable.on('fileSuccess', (file, message) => {
            this.onFileSuccess(file, message);
        });

        this.resumable.on('fileError', (file, message) => {
            this.onFileError(file, message);
        });

        this.resumable.on('progress', () => {
            this.onProgress();
        });

        this.resumable.on('pause', () => {
            this.onPause();
        });
    }

    onFileAdded(file, event) {
        this.file = file;

        this.$scope.$apply();
    }

    onFileSuccess(file, result) {
        this.completeCallback({result: JSON.parse(result)});
    }

    onFileError(file, result) {
        this.progress = 0;

        this.$timeout(() => {
            if (!this.$scope.$$phase) {
                this.$scope.$apply();
            }
        }, 500);

        this.progressCallback({result: this.progress});

        this.errorCallback({result: JSON.parse(result)});
    }

    onProgress() {
        this.progress = Math.round(this.resumable.progress() * 100);

        this.$timeout(() => {
            if (!this.$scope.$$phase) {
                this.$scope.$apply();
            }
        }, 500);

        this.progressCallback({result: this.progress});
    }

    onPause() {

    }
}

let uploaderComponent = {
    bindings: {
        'path': '@',
        'name': '@',
        'allowedExtensions': '=?',
        'completeCallback': '&?',
        'errorCallback': '&?',
        'progressCallback': '&?'
    },
    template: uploaderHtml,
    controller: uploaderController
};

export default uploaderComponent;
